import lodashGet from 'lodash/fp/get';
import lodashKeyBy from 'lodash/fp/keyBy';
import typeCheck from 'common/util/typeCheck';

import {
  TENANT_ALERT_SERVICE_LIST,
} from 'common/tenantAlertConstants';

const keyByServiceId = lodashKeyBy('service_id');

export function getTenantAlertApplicationReports({ tenantAlertApplication, tenantAlertServiceId }) {
  typeCheck('tenantAlertApplication::NonEmptyObject', tenantAlertApplication);

  const reportsByServiceId = keyByServiceId(lodashGet('reports', tenantAlertApplication) || []);
  const reports = TENANT_ALERT_SERVICE_LIST
    .map((serviceId) => reportsByServiceId[serviceId])
    .filter((report) => report);

  if (tenantAlertServiceId) {
    return reports.filter((report) => report.service_id === `${tenantAlertServiceId}`);
  }

  return reports;
}
